class Accordion {
  constructor(element) {
    this.element = element;
    this.$toggler = this.element.querySelector('.js-accordion-toggle');
    this.$region = this.element.querySelector('.js-accordion-region');
    this.openClass = 'is-open';
    this.$toggler.addEventListener('click', this.toggleState.bind(this));
    if (
      window.location.hash &&
      this.element.querySelector(window.location.hash)
    ) {
      this.element.querySelector(window.location.hash).click();
    }
  }

  toggleState(_e) {
    if (this.element.classList.contains(this.openClass)) {
      this.element.classList.remove(this.openClass);
      this.$region.setAttribute('aria-expanded', false);
    } else {
      this.element.classList.add(this.openClass);
      this.$region.setAttribute('aria-expanded', true);
    }
  }
}

export default Accordion;
